
import useRequest from '@/websdk/utils/request';

export default (function () {
  const { data, isRequestSuccessed } = useRequest({
    url: '/api/moulds?page_no=1&page_size=10&orders=asc&order_by=sn',
    name: 'GET_MOULDS_ONE_PAGE',
    method: 'GET'
  });
  return [data || {}, isRequestSuccessed];
});